import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './styles.css';

class Slider extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    backgroundColor: PropTypes.string.isRequired,
  };

  state = {
    marginLeft: 0,
    selectedItem: 0,
  };

  componentDidMount() {
    // window.addEventListener('resize', this.handleResize());
    this.resetMargin();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize());
  }

  static getElementWidth(targetNode) {
    const { width } = targetNode.getBoundingClientRect();

    const computedStyle = window.getComputedStyle(targetNode);
    const marginLeft = Number(computedStyle.marginLeft.replace('px', ''));
    const marginRight = Number(computedStyle.marginRight.replace('px', ''));

    const totalWidth = width + marginLeft + marginRight;
    return totalWidth;
  }

  handleLeftClicked = () => {
    const { marginLeft, selectedItem } = this.state;
    const destinationItem = Math.max(selectedItem - 1, 0);

    const itemWidth = Slider.getElementWidth(this.sliderContent.childNodes[destinationItem]);

    this.setState({
      marginLeft: Math.max(marginLeft - itemWidth, 0),
      selectedItem: destinationItem,
    });
  }


  handleRightClicked = () => {
    const { marginLeft, selectedItem } = this.state;
    const currentMarginLeft = marginLeft;
    const destinationItem = selectedItem;

    const itemWidth = Slider.getElementWidth(this.sliderContent.childNodes[destinationItem]);

    this.setState({
      marginLeft: currentMarginLeft + itemWidth,
      selectedItem: Math.min(destinationItem + 1, this.sliderContent.childNodes.length - 1),
    });
  }

  handleResize = () => {
    this.updateFn = this.updateFn || _.debounce(() => { this.resetMargin(); }, 200);
    return this.updateFn;
  }

  resetMargin() {
    if (this.slider && this.sliderContent) {
      this.setState({ marginLeft: 0 });
    }
  }

  renderSliderArrow(sideOfSlider, onClickMethod) {
    const { backgroundColor } = this.props;
    const caretDirectionClass = sideOfSlider === 'left' ? styles.caretLeft : styles.caretRight;
    const gradientDirection = sideOfSlider === 'left' ? 'right' : 'left';
    const chevronIcon = sideOfSlider === 'left' ? faChevronLeft : faChevronRight;

    return (
      <button
        type="button"
        className={`${styles.caret} ${caretDirectionClass}`}
        onClick={onClickMethod}
        style={{ background: `linear-gradient(to ${gradientDirection}, ${backgroundColor} 50%,rgba(0,0,0,0) 100%)` }}
      >
        <FontAwesomeIcon icon={chevronIcon} />
      </button>
    );
  }

  renderLeftArrow() {
    const { marginLeft } = this.state;
    const sliderWidth = this.slider ? this.slider.offsetWidth : 0;
    const contentWidth = this.sliderContent ? this.sliderContent.offsetWidth : 0;
    if ((contentWidth > sliderWidth) && marginLeft !== 0) {
      return this.renderSliderArrow('left', this.handleLeftClicked);
    }
    return null;
  }

  renderRightArrow() {
    const { marginLeft } = this.state;
    const sliderWidth = this.slider ? this.slider.offsetWidth : 0;
    const contentWidth = this.sliderContent ? this.sliderContent.offsetWidth : 0;
    const remainingWidth = contentWidth - sliderWidth - marginLeft;

    if (remainingWidth > 0) {
      return this.renderSliderArrow('right', this.handleRightClicked);
    }
    return null;
  }

  render() {
    const { marginLeft } = this.state;
    const { children } = this.props;

    return (
      <div className={styles.navigationSlider} ref={(e) => { this.slider = e; }}>
        {this.renderLeftArrow()}
        <div className={styles.sliderWrapper}>
          <div
            className={styles.sliderContent}
            ref={(e) => { this.sliderContent = e; }}
            style={{ marginLeft: `${Number(-1 * marginLeft)}px` }}
          >
            {children}
          </div>
        </div>
        {this.renderRightArrow()}
      </div>
    );
  }
}

export default Slider;
